// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__34mLF","pdfNav":"styles_pdfNav__-BZT2"};